import { initializeApp } from 'firebase/app'
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check'
import { ref, get, child, getDatabase, push } from 'firebase/database'
import { createContext } from 'react'
import { mod1271_36 } from 'cdigit'



export const USER_ID_LOCAL_STORAGE_KEY = 'sexumfrageID'
const dbname = 'sex-umfrage-2024'
// @ts-ignore

const useDebug = false

export const app = initializeApp({
  databaseURL: useDebug
    ? 'http://127.0.0.1:9000/?ns='+dbname
    : 'https://'+dbname+'.europe-west1.firebasedatabase.app/',
  apiKey: 'AIzaSyDj4VVmQgxfq-59EBB4pZUVBZOOiE_FsPE',
  authDomain: 'captchadatabases.firebaseapp.com',
  projectId: 'captchadatabases',
  storageBucket: 'captchadatabases.appspot.com',
  messagingSenderId: '78621128630',
  appId: '1:78621128630:web:5b1182f6b86e20765df317',
})

// reCaptcha v3
const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider(
    "6LffZUYqAAAAAM4Fsz5zOSSAqM_6qan1Wy5Oj9Dh"
  ),
  isTokenAutoRefreshEnabled: true,
});

// Get a reference to the database service and provide it via context
const db = getDatabase(app)
const users = ref(db, 'users')
const data = ref(db, 'data')
const dbRef = ref(db)
let uniqueId 

try {
  uniqueId =
    localStorage.getItem(USER_ID_LOCAL_STORAGE_KEY) ||
    mod1271_36.generate(
      push(child(ref(db), '/')).key ||
        Math.random().toString(36).substring(2, 15)
    )
} catch {
  console.log('cannot access local storage')
}

uniqueId && localStorage.setItem(USER_ID_LOCAL_STORAGE_KEY, uniqueId)
export const firebaseContext = createContext({
  db,
  users,
  data,
  dbRef,
  uniqueId,
})
